import RebatePeriodCard from './RebatePeriodCard';

export default RebatePeriodCard;
